import { createStore } from 'redux';
import { DefaultRootState } from 'react-redux';
import { UnitPriceType } from './types/unit-price';
import { TenantItem, TenantInformation } from './types/tenant';
import { TaskItem } from './types/to-do';
import {
  SiteNotEligibleForBidding,
  PeriodOutsideOfSiteBiddingPlan,
  SiteInformationItem,
} from './types/sites-not-eligible-for-bidding';
import {
  BiddingPlanRevenueItem,
  UnitPriceCorrectionStatusItem,
  BiddingPlanStatusDataItem,
} from './types/bid-plan-type';
import { ServicePermission } from './types/service';
import { AuthUser } from '@aws-amplify/auth';
export interface ApplicationState extends DefaultRootState {
  spinner: boolean;
  sidebarShow: boolean | '' | 'responsive' | undefined;
  sidebarMinimize: boolean;

  cognitoUser: AuthUser | null;
  correctedUnitPrice: UnitPriceType[];
  tenant_id: string;
  // tenantList: TenantItem[];
  tenantInformation: TenantInformation | null;
  taskList: TaskItem[];
  sitesNotEligibleForBidding: SiteNotEligibleForBidding[];
  siteInformationList: SiteInformationItem[];
  periodOutsideOfSiteBiddingPlan: PeriodOutsideOfSiteBiddingPlan[];
  siteInformation: SiteInformationItem | null;
  biddingPlanRevenueInformation: BiddingPlanRevenueItem[];
  unitPriceCorrectionStatus: UnitPriceCorrectionStatusItem[];
  lang: string;
  downloadCsvStatus: {
    executionArn: string;
    status?: string;
    responseBody: string;
  };
  biddingPlanStatusDataList: BiddingPlanStatusDataItem[];
  servicePermissions: ServicePermission[];
  isDirty: boolean;
}

const initialState: ApplicationState = {
  spinner: false,
  sidebarShow: 'responsive',
  sidebarMinimize: false,

  cognitoUser: null,
  correctedUnitPrice: [],
  tenant_id: '',
  // tenantList: [],
  tenantInformation: null,
  taskList: [],
  sitesNotEligibleForBidding: [],
  siteInformationList: [],
  periodOutsideOfSiteBiddingPlan: [],
  siteInformation: null,
  biddingPlanRevenueInformation: [],
  unitPriceCorrectionStatus: [],
  lang: 'jp',
  downloadCsvStatus: {
    executionArn: '',
    status: undefined,
    responseBody: '',
  },
  biddingPlanStatusDataList: [],
  servicePermissions: [],
  isDirty: false
};

const changeState = (state = initialState, { type, ...rest }: Record<string, any>) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    case 'clear':
      return {
        ...initialState,
        lang: state.lang,
      };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
